import React, { FC, ReactNode, CSSProperties } from 'react';
import { Space, Typography } from 'antd';

import './page-header.scss';

const { Title } = Typography;

interface PageHeaderProps {
    title: ReactNode;
    subTitle?: ReactNode;
    extra?: ReactNode | ReactNode[];
    footer?: ReactNode;
    onBack?: () => void;
    backIcon?: ReactNode;
    style?: CSSProperties;
}

const PageHeader: FC<PageHeaderProps> = ({
    title,
    subTitle,
    extra,
    footer,
    onBack,
    backIcon,
    style,
}) => {
    const renderTitle = () => {
        if (typeof title === 'string') {
            return (
                <Title level={4} className="page-header__title">
                    {title}
                </Title>
            );
        }
        return title;
    };

    return (
        <div className="page-header" style={style}>
            <div className="page-header__heading">
                <div className="page-header__heading-left">
                    {onBack && (
                        <span
                            className="page-header__back"
                            onClick={onBack}
                            role="button"
                            tabIndex={0}
                            onKeyDown={(e) => e.key === 'Enter' && onBack()}
                        >
                            {backIcon ?? <span>&larr;</span>}
                        </span>
                    )}
                    <Space size={8} align="center">
                        {renderTitle()}
                        {subTitle && <span className="page-header__subtitle">{subTitle}</span>}
                    </Space>
                </div>
                {extra && (
                    <div className="page-header__extra">
                        {Array.isArray(extra)
                            ? extra.map((item, i) => <React.Fragment key={i}>{item}</React.Fragment>)
                            : extra}
                    </div>
                )}
            </div>
            {footer && <div className="page-header__footer">{footer}</div>}
        </div>
    );
};

export { PageHeader };
export type { PageHeaderProps };
